// extracted by mini-css-extract-plugin
export default {"publicMint":"PublicMint_publicMint__jV7Sy","mobileOnly":"PublicMint_mobileOnly__AJIRq"};